module.exports = "/dashboard/manage/users/components/userBaseWageComponent-5b28e4.html";